import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showApiErrorToast, showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface DeleteCalendarEventParams {
  id: string
}

const deleteCalendarEvent = async ({ id }: DeleteCalendarEventParams): Promise<void> => {
  await api.delete(`/calendar-event/${id}`)
}

export const useDeleteCalendarEvent = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, DeleteCalendarEventParams>({
    mutationFn: deleteCalendarEvent,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.eventDeleted'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['calendar-events'] }),
        queryClient.invalidateQueries({ queryKey: ['calendar-event', variables.id] }),
      ])
    },
    // A refused deletion (a guest's, for one) says so.
    onError: (error) => {
      showApiErrorToast(t, error)
    },
  })
}

